module.exports = __webpack_public_path__ + "static/img/3d.5ddea4bd.jpg";